import { ActionButton, GetThemeValueForKey, Image } from '@my/ui'
import { color, getImageColorStyle, MiscUtils } from '@my/util'

// IconButton Props
interface IconButtonProps {
  onPress?: () => void
  iconSource: any
  iconTintColor?: string
  iconWidth?: number
  iconHeight?: number
  buttonSize?: number
  backgroundColor?: GetThemeValueForKey<'backgroundColor'>
}

// IconButton Component
export const IconButton: React.FC<IconButtonProps> = (props) => {
  const { onPress, iconSource, iconTintColor, iconWidth, iconHeight, buttonSize, backgroundColor } =
    props
  return (
    <ActionButton
      unstyled
      onPress={onPress ?? onPress}
      alignItems="center"
      justifyContent="center"
      width={buttonSize ?? 40}
      height={buttonSize ?? 40}
      borderRadius={buttonSize ?? 40 / 2}
      backgroundColor={backgroundColor ?? color.tzaGreen}
      hoverStyle={{backgroundColor: color.lightGrey}}
      {...MiscUtils.ui.shadowGenerator(.2,5)}
    >
      <Image
        resizeMode="contain"
        src={iconSource}
        style={{
          ...getImageColorStyle(iconTintColor ?? color.white),
          width: iconWidth ?? 20, 
          height: iconHeight ?? 20, 
        }}
      />
    </ActionButton>
  )
}
